import React from 'react';

import ConvertNumber from "./ConvertNumber";

import ToolPanel from "../component/ToolPanel";

function Math (props) {
  return (
    <>
      <ToolPanel title="Convert Number"
                 tag="convert-number">
        <ConvertNumber />
      </ToolPanel>
    </>
  );
}

export default Math;
